module.exports = __webpack_public_path__ + "img/valores.7d379413.png";